// extracted by mini-css-extract-plugin
export default {"main":"PageFailed_main__2a1JC","buttons":"PageFailed_buttons__eaqfG","modal":"PageFailed_modal__DEFw8","backdrop":"PageFailed_backdrop__+DiSI"};